import { CONDITIONS } from 'site-modules/shared/constants/appraisal/appraisal';

export const ESTIMATED_VALUES_CONDITION = [
  CONDITIONS.OUTSTANDING,
  CONDITIONS.CLEAN,
  CONDITIONS.AVERAGE,
  CONDITIONS.ROUGH,
];
